/* istanbul ignore file */
import React from 'react';
import { useUiTheme } from 'framework/uiTheme';
import EqCondition from './condition/EqCondition';
import { CheckboxGroupProps } from 'framework/form';

export type CheckboxGroupLayoutType = ReactComponent<CheckboxGroupProps>;

const CheckboxGroupFilter = ({ source, ...props }: CheckboxGroupProps) => {
  const { CheckboxGroupFilterLayout } = useUiTheme<CheckboxGroupLayoutType>();

  return (
    <EqCondition source={source}>
      <CheckboxGroupFilterLayout {...props} source={source} />
    </EqCondition>
  );
};

export default CheckboxGroupFilter;
